module.exports = __webpack_public_path__ + "static/media/728x90_0004_ro.7872dc1d.jpg";